var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.75C0.5 0.7835 1.2835 0 2.25 0H4.75C5.16421 0 5.5 0.33579 5.5 0.75C5.5 1.16421 5.16421 1.5 4.75 1.5H2.25C2.11193 1.5 2 1.61193 2 1.75V12.25C2 12.3881 2.11193 12.5 2.25 12.5H4.75C5.16421 12.5 5.5 12.8358 5.5 13.25C5.5 13.6642 5.16421 14 4.75 14H2.25C1.2835 14 0.5 13.2165 0.5 12.25V1.75ZM10.9393 6.25H5.25002C4.83581 6.25 4.50002 6.58579 4.50002 7C4.50002 7.41422 4.83581 7.75 5.25002 7.75H10.9393L8.9697 9.7197C8.6768 10.0126 8.6768 10.4874 8.9697 10.7803C9.2626 11.0732 9.7374 11.0732 10.0303 10.7803L13.2803 7.53033C13.5732 7.23744 13.5732 6.76256 13.2803 6.46967L10.0303 3.21967C9.7374 2.92678 9.2626 2.92678 8.9697 3.21967C8.6768 3.51256 8.6768 3.98744 8.9697 4.28033L10.9393 6.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.b23a74d9ab10fa3e07d0436b76253df2.svg";
export { ForwardRef as ReactComponent };